import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useBlogContext } from "../../fetchdata/BlogContext";
import axios from "axios";

const Footer = ({navbar}) => {
  const { Headers, isHeader, cartItems, AllProducts, AllCategoriess } =
    useBlogContext();

  return (
    <>


      {/* Footer */}
      <footer className="footer">
        <div className="footer-top py-4 py-lg-10 border-top">
          <div className="container">
          
              {isHeader
                ? // Display loading skeletons while data is being fetched
                  Array.from({ length: 12 }).map((_, index) => (
                    <div className="nav-item col-2 mb-3" key={index}>
                      <div
                        className="skeleton mt-1"
                        style={{
                          height: 22,
                          width: 100,
                          borderRadius: 5,
                        }}
                      ></div>
                    </div>
                  ))
                : Headers.footer !== undefined &&
                  Headers.footer.slice(3, 100).map((item, index) => (
                      <div className="row g-4 border-bottom mb-4 pb-2 pt-4">
                    <div className="m-0" key={index}>
                      <div className="widget widget-links">
                        <nav aria-label="breadcrumb">
                          <ol className="breadcrumb">
                            <li
                              className="breadcrumb-item active"
                              aria-current="page"
                            >
                              {" "}
                              <h4 className="widget-title mb-0 fw-medium h6 text-dark">
                                {item.text}
                              </h4>{" "}
                            </li>
                            {item.children.map((childItem, childIndex) => (
                              <li
                                key={childIndex}
                                className="breadcrumb-item pe-2"
                                aria-current="page"
                              >
                                <Link
                                  className="widget-list-link text-dark "
                                  style={{ whiteSpace: "nowrap" }}
                                  to={childItem.link}
                                >
                                  {childItem.text}
                                </Link>
                              </li>
                            ))}
                          </ol>
                        </nav>
                      </div>
                    </div>
                              </div>
                  ))}
  

            <div className="row g-4 g-lg-10">
              <div className="col-lg-9">
                <div className="row g-4">

                  
                  {isHeader
                    ? // Display loading skeletons while data is being fetched
                      Array.from({ length: 12 }).map((_, index) => (
                        <div className="nav-item col-4" key={index}>
                          <div
                            className="skeleton mt-1"
                            style={{
                              height: 22,
                              width: 100,
                              borderRadius: 5,
                            }}
                          ></div>
                        </div>
                      ))
                    : Headers.footer !== undefined &&
                      Headers.footer.slice(0, 3).map((item, index) => (
                        <div className="col px-md-4" key={index}>
                          <div className="widget widget-links">
                            <h4 className="widget-title fw-medium h6 text-dark fw-bold">
                              {item.text}
                            </h4>
                            <ul className="widget-list">
                              {item.children.map((childItem, childIndex) => (
                                <li
                                  className="widget-list-item"
                                  key={childIndex}
                                >
                                  <Link
                                    className="widget-list-link text-dark "
                                    to={childItem.link}
                                  >
                                    {childItem.text}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      ))}
                </div>
              </div>
              <div className="col-lg-3">
                <div className="mb-4">
                  <h4 className="mb-2 h4 fw-medium h6 text-dark fw-bold">
                    CONTACT US
                  </h4>
                </div>
                <div className="mb-4">
                  <div className="row align-items-center">
                    <div className="col-auto">
                      
                      <i className="text-dark ri-phone-fill"   style={{ fontSize: "2rem" }}
                       ></i>

                    </div>
                    {!isHeader && (
                      <div className="col">
                        <h6 className="mb-0 h6 text-dark">24/7 Tech Support</h6>
                        <a
                          href={`tel:+91${Headers.phone}`}
                          className="nav-link-base h6 fw-light text-dark"
                        >
                          +91 {Headers.phone}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-4">
                  <div className="row">
                    <div className="col-auto">
                      <i
                        className="text-dark ri-map-2-fill"
                        style={{ fontSize: "2rem" }}
                      />
                    </div> 
                    {!isHeader && (
                      <div className="col">
                        <h6 className="mb-1 font-weight-bold h6 text-dark">
                          Address Info
                        </h6>
                        <span className="h6 fw-light text-dark"> {Headers.address}</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-4">
                  <div className="row">
                    <div className="col-auto">
                      <i
                        className="text-dark ri-mail-fill"
                        style={{ fontSize: "2rem" }}
                      />
                    </div>
                    {!isHeader && (
                      <div className="col">
                        <h6 className="mb-0 h6 text-dark">24/7 Email Support</h6>
                        <a
                          href={`mailto:${Headers.email}`}
                          className="nav-link-base h6 fw-light text-dark "
                        >
                          {Headers.email}
                        </a> 
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom border-top py-4 bg-white">
          <div className="container">
            <div className="row align-items-center">
       

                     <div className="col-12 col-lg-3 text-center text-lg-start mt-3 mt-lg-0">
                     {Headers.meta_logo && Headers.meta_logo !== undefined ? (
                    <img
                      src={Headers.meta_logo}
                      width={120}
                      alt="logo"
                      style={{
                        maxHeight: 50,
                        width: "auto",
                        filter: "grayscale(0)",
                        mixBlendMode: "multiply",
                      }}
                      className="mb-2"
                    />
                  ) : (
                    <div
                      className="card-1 skeleton"
                      style={{
                        borderRadius: 5,
                        aspectRatio: "142/25",
                        width: "100%",
                        height: 50,
                      }}
                    ></div>
                  )}
          </div>


              <div className="col-12 col-lg-6 text-center ">
             

                <p
                  title="https://seotowebdesign.com/"
                  className="nav-link-base m-0 "
                >
                  {!isHeader && Headers.footer_credit}| Design by{" "}
                  <a href="https://seotowebdesign.com/" target="blank" className="text-dark ">
                    Seo To Webdesign{" "}
                  </a>
                </p>
              </div>

           
              <div className="col-12 col-lg-3 text-center text-lg-end">
                <ul className="list-inline mb-0 gap-2 ">
                  <li className="list-inline-item">
                    <a className="text-secondary fs-xl" href="#">
                    <i className="ri-facebook-circle-fill"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a className="text-secondary fs-xl" href="#">
                    <i className="ri-twitter-fill"></i>
                    </a>
                  </li>

                  <li className="list-inline-item">
                    <a className="text-secondary fs-xl" href="#">
                    <i className="ri-instagram-fill"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a className="text-secondary fs-xl" href="#">
                    <i className="ri-youtube-fill"></i>
                    </a>
                  </li>
                   
                </ul>
              </div>


            </div>
          </div>
        </div>
      </footer>
{navbar !== false && 

      <navbar className="d-md-block d-flex mynavbar shadow px-4 py-2 justify-content-between">


        <div className="nav_item">
          <NavLink to="/" className="w-100 d-flex flex-column justify-content-center align-items-center" >
          <i class="ri-home-6-line"/>
           <span>   Home </span>  
          </NavLink>
        </div>

  <div className="nav_item">
  <NavLink
    className="w-100 d-flex flex-column justify-content-center align-items-center"
    to="/home"
  >
    <i className="ri-group-3-fill " /> <span> Bussiness Partner </span>
  </NavLink>
</div>

<div className="nav_item">
  <NavLink
    className="w-100 d-flex flex-column justify-content-center align-items-center "
    to="/cart"
  >  <div className="position-relative">
     {cartItems && cartItems.length > 0 &&  <> <p className="d-inline-block small p-0 m-0 position-absolute rounded-pill text-center bg-primary text-white fw-light" style={{
        top:'-1px',width:21,height:21,transform: 'scale(0.8)',right:'-10px'
       }} > {cartItems.length} </p> </> }
    <i className="ri-shopping-bag-3-fill" />  
    </div>
  </NavLink>
</div>

<div className="nav_item">
  <NavLink
    className="w-100 d-flex flex-column justify-content-center align-items-center"
    to="/account"
  >
    <i className="ri-account-circle-fill" /> <span> User </span>
  </NavLink>
</div>
 

      </navbar>
 }
    </>
  );
};

export default Footer;
